import { useState } from "react";
import { Dialog } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface TempPasswordDialogProps {
  open: boolean;
  email: string;
  password: string;
  onClose: () => void;
}

export function TempPasswordDialog({
  open,
  email,
  password,
  onClose,
}: TempPasswordDialogProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(password);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard API unavailable; ignore — the password is visible on screen.
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Temporary password"
      description={`Save this password for ${email}. It will not be shown again.`}
      testId="temp-password-dialog"
    >
      <div className="flex items-center gap-2 mb-5">
        <code
          data-testid="temp-password-value"
          className="flex-1 bg-page border border-border-subtle rounded px-3 py-2.5 font-mono text-sm text-green-400 break-all"
        >
          {password}
        </code>
        <Button
          type="button"
          variant="secondary"
          onClick={handleCopy}
          data-testid="copy-button"
        >
          {copied ? "Copied" : "Copy"}
        </Button>
      </div>
      <div className="flex justify-end">
        <Button type="button" onClick={onClose} data-testid="done-button">
          Done
        </Button>
      </div>
    </Dialog>
  );
}
